import styled from 'styled-components';

export const CardTitle = styled.div`
  font-size: 2rem;
  font-weight: 700;
  font-family: Quicksand, 'sans-serif';
  color: #3e475e;
`;
